import { Stack } from '@mui/material';

import { api } from 'common';
import { FlowDefinition } from 'vivaa-api';

import { HieQueryDocumentsBlockDocumentationMarkdown } from './documentation';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { BlockTextField } from '../../ConfigFields/TextField';
import type { BlockConfigProps } from '../../types';

const { DurationUnits } = FlowDefinition;
type DurationUnits = FlowDefinition.DurationUnits;

const PATIENT_SOURCE_HELPER_TEXT = `Select which upstream block to pull Patient data from.`;

function FormFields() {
  return (
    <Stack spacing={2}>
      <ParentBlockSelectField
        fieldName="config.patient.sourceBlockName"
        label="Patient Source"
        required
        helperText={PATIENT_SOURCE_HELPER_TEXT}
      />
      <BlockTextField
        fieldName="config.facilityId"
        label="Facility ID"
        required
        helperText="The HIE facility ID"
      />
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[DurationUnits.Hours, DurationUnits.Minutes, DurationUnits.Seconds]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
        valueHelperText="Will fail if block does not complete after duration"
      />
    </Stack>
  );
}

export const hieQueryDocumentsConfig: BlockConfigProps<
  api.FlowDefinition.HieQueryDocumentsBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'hieQueryDocuments',
  defaultConfig: {
    patient: {
      sourceBlockName: '',
    },
    facilityId: '',
    timeout: {
      value: 10,
      units: DurationUnits.Minutes,
    },
  },
  configFields: {
    schema: api.FlowDefinition.HieQueryDocumentsBlockConfigSchema,
    FormFields,
  },
  documentationMarkdown: HieQueryDocumentsBlockDocumentationMarkdown,
};
